// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';

export const SearchPreferences = t.struct({
    countryCode: t.String,
    stateCodes: t.list(t.String)
}, {
    defaultProps: {
        countryCode: '',
        stateCodes: []
    },
    name: 'SearchPreferences',
    strict: true
});
